import { forwardRef } from "react";

import classNames from "@/helpers/classNames";

export type ButtonProps = {
  isFocused?: boolean;
  isDisabled?: boolean;
} & React.ComponentPropsWithoutRef<"button">;

const InputContainerButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { className, isDisabled, isFocused, ...restProps } = props;

    return (
      <button
        tabIndex={-1}
        ref={ref}
        type="button"
        className={classNames(
          "group relative flex h-12 w-full cursor-default items-center rounded-xs border bg-background text-left transition-all duration-300 focus:outline-hidden",
          isFocused && "border-blue-500 ring-2 ring-blue-600",
          isDisabled
            ? "cursor-not-allowed bg-gray-200/70 dark:bg-black/10"
            : "hover:border-gray-400",
          className,
        )}
        {...restProps}
      >
        {props.children}
      </button>
    );
  },
);

export default InputContainerButton;
